import Vue from 'vue'
import Vuex from 'vuex'
import constTypes from './constTypes.js'
import mutations from './mutations.js'
import getters from './getters.js'
import actions from './actions.js'


Vue.use(Vuex);

const state = {
	user: {
		UserID: 0
	},
	 
	shop: [],
	shopName:'',
	CategoryMenu: [],
	Writer: [],
	Classification: [],
	Transporter:[],
	
}
const store = new Vuex.Store({
	state,
	mutations,
	actions,
	getters,
	//getter相当于计算属性
	modules: {
		//如果这里需要抽离的话就需要单独配置，模块，每个模可以有独立的state mutation getters action 

	}
});

export default store
